import type { ChangeMeta } from 'react-number-format';

/** При вставке react-number-format не всегда отдаёт meta — считаем, что вставили строку целиком. */
export const getFallbackChangeMeta = (value: string): ChangeMeta => ({
  from: { start: 0, end: 0 },
  to: { start: 0, end: value.length },
  lastValue: '',
});
